export default "__VITE_ASSET__kJDhJgOs__"